import qs from 'qs';
import request from '../index';
/* 和售后菜单权限有关的接口 */

/**
* APermissions
* @params {string} data.icon 图标
* @params {number} data.id
* @params {string} data.identify 权限标识
* @params {string} data.name 权限名称
* @params {number} data.pid 子父节点
* @params {number} data.sort 排序
* @params {number} data.type 权限类型
*/

/**
* 根据权限id删除售后权限
* @params {} params.id 权限id
*/
export const deletePermission = (data) => request.delete('/api-qc/permissions/deletePermission', data);

/**
* 获取所有售后权限的树结构
*/
export const getPermissionTree = (params) => request.get('/api-qc/permissions/getPermissionTree', { params });

/**
* 根据售后id获取已选权限id集合
* @params {} params.afterSaleId 售后Id
*/
export const getPermissionsByUserId = (params) => request.get('/api-qc/permissions/getPermissionsByUserId', { params });

/**
* 给售后用户添加权限
* @params {number} params.afterSaleId afterSaleId
* @params {array} permissionIds
*/
export const insertPermissionUser = (params, data) => request.post(`/api-qc/permissions/insertPermissionUser?${qs.stringify(params)}`, data);

/**
* 添加或更新售后权限
* @params {APermissions} aPermissions
*/
export const saveOrUpdatePermission = (data) => request.post('/api-qc/permissions/saveOrUpdatePermission', data);
